<template>
  <div class="vx-col w-full">
    <vx-card title="Guarantor Information Form" action-buttons>
      <div class="mt-5">
        <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" finishButtonText="Submit">

          <tab-content title="Personal Information" :before-change="validateStep1" class="mb-5" icon="feather icon-home">
            <br>
            <!-- tab 1 content -->
            <form data-vv-scope="step-1">
              <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full mt-2">
                      <span>Guarantor’s Name (with Nick Name)</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <vs-input class="w-full" type="text" v-model="personal.applicantName"/>
                    </div>
                  </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full mt-2">
                      <span>Father’s Name</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <vs-input class="w-full" type="text" v-model="personal.fathersName"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full mt-2">
                      <span>Mother’s Name</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <vs-input class="w-full" type="text" v-model="personal.motherName"/>
                    </div>
                  </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full mt-2">
                      <span>Spouse Name</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <vs-input class="w-full" type="text" v-model="personal.spouseName"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full mt-2">
                      <span>Age</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <ul class="demo-alignment">
                        <li>
                          <vs-radio v-model="personal.age" vs-value="18-25">18-25</vs-radio>
                        </li>
                        <li>
                          <vs-radio v-model="personal.age" vs-value="26-35">26-35</vs-radio>
                        </li>
                        <li>
                          <vs-radio v-model="personal.age" vs-value="36-45">36-45</vs-radio>
                        </li>
                        <li>
                          <vs-radio v-model="personal.age" vs-value="46-55">46-55</vs-radio>
                        </li>
                        <li>
                          <vs-radio v-model="personal.age" vs-value="56-65">56-65</vs-radio>
                        </li>
                        <li>
                          <vs-radio v-model="personal.age" vs-value="66+">66+</vs-radio>
                        </li>
                      </ul>
                      <!--<datepicker placeholder="Select Date" v-model="birthDate"></datepicker>-->
                    </div>
                  </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full mt-4">
                      <span>Marital Status</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <ul class="demo-alignment">
                        <li>
                          <vs-radio v-model="personal.maritalStatus" vs-value="Single">Single</vs-radio>
                        </li>
                        <li>
                          <vs-radio v-model="personal.maritalStatus" vs-value="Married">Married</vs-radio>
                        </li>
                        <li>
                          <vs-radio v-model="personal.maritalStatus" vs-value="Separated">Separated</vs-radio>
                        </li>
                        <li>
                          <vs-radio v-model="personal.maritalStatus" vs-value="Divorced">Divorced</vs-radio>
                        </li>
                        <li>
                          <vs-radio v-model="personal.maritalStatus" vs-value="Widowed">Widowed</vs-radio>
                        </li>
                      </ul>

                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full mt-4">
                      <span>Gender</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <ul class="demo-alignment">
                        <li>
                          <vs-radio v-model="personal.gender" vs-value="Male">Male</vs-radio>
                        </li>
                        <li>
                          <vs-radio v-model="personal.gender" vs-value="Female">Female</vs-radio>
                        </li>
                        <li>
                          <vs-radio v-model="personal.gender" vs-value="Others">Others</vs-radio>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full mt-4">
                      <span>Head of Household</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <ul class="demo-alignment">
                        <li>
                          <vs-radio v-model="personal.headOfHousehold" :vs-value="true">Yes</vs-radio>
                        </li>
                        <li>
                          <vs-radio v-model="personal.headOfHousehold" :vs-value="false">No</vs-radio>
                        </li>
                      </ul>

                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full mt-4">
                      <span>Education Level</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <template>
                        <v-select label="text" v-model="personal.education" class="w-full select-large"
                                  :options="educationLevelOpt" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full mt-2">
                      <span>NID No</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <vs-input class="w-full" type="number" v-model="personal.nidNo" name="nid_No"/>
                      <span v-if="showNidError" class="text-danger">Nid No is required</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col sm:w-1/3 w-full mb-2">
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full mt-16">
                      <span>Nid Front</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <template>
                        <vs-upload text="NID Front" v-model="personal.nidFrontImage"
                                   @on-success="successNidUpload"/>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full mt-16">
                      <span>Nid Back</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <template>
                        <vs-upload text="NID Back" action="https://jsonplaceholder.typicode.com/posts/"
                                   @on-success="successNidUpload"/>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full mt-16">
                      <span>Upload Photo</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                      <template>
                        <vs-upload text="Photo Upload" action="https://jsonplaceholder.typicode.com/posts/"
                                   @on-success="successUpload"/>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full text-right">
                  <vs-button :v-disabled="personal.nidNo === null"
                             color="success" class="mr-3 mb-2 float-right" @click="savaPersonalInfoifNoError()">Save
                  </vs-button>

                </div>
              </div>
            </form>
          </tab-content>

          <!-- tab 2 Contact -->
          <tab-content title="Contact Information" :before-change="beforeTabSwitch2" class="mb-5"
                       icon="feather icon-briefcase">
            <br>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full mt-2">
                    <span>Mobile</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" disabled type="number" v-model="contact.mobile"/>
                  </div>
                </div>
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full mt-2">
                    <span>Other Phone</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="number" v-model="contact.otherPhone"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full mt-2">
                    <span>Email</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="email"  v-model="contact.email"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-col w-full">
                  <vx-card title="Present Address">
                    <div class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span>Division</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <!--                    <vs-select v-model="tDevision" class="w-full select-large">-->
                        <!--                      <vs-select-item :key="index" :value="item.id" :text="item.name"-->
                        <!--                                      v-for="(item,index) in division" class="w-full"/>-->
                        <!--                    </vs-select>-->
                        <template>
                          <v-select label="name" v-model="contact.tDevision" class="w-full select-large"
                                    :options="division"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                        </template>
                      </div>
                    </div>
                    <div v-if="contact.tDevision" class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span>District</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <template>
                          <v-select label="name" v-model="contact.tDistrict" class="w-full select-large"
                                    :options="district"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                        </template>
                      </div>
                    </div>
                    <div v-if="contact.tDistrict" class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span>Thana</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <template>
                          <v-select label="name" v-model="contact.tThana" class="w-full select-large" :options="thana"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                        </template>
                      </div>
                    </div>
                    <div v-if="contact.tThana" class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span>Apt#/House#/Road#/Village#</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <vs-input class="w-full" type="text" v-model="contact.tAptHouseRoadVill"/>
                      </div>
                    </div>
                    <div v-if="contact.tAptHouseRoadVill" class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span>Nearby Famous Landmark </span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <vs-input class="w-full" type="text" v-model="contact.tNearByLandmark"/>
                      </div>
                    </div>
                    <div v-if="contact.tNearByLandmark" class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span>Postal code</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <vs-input class="w-full" type="text" v-model="contact.tPostalCode"/>
                      </div>
                    </div>
                    <div v-if="contact.tPostalCode" class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span>Household Type</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <ul class="demo-alignment">
                          <li>
                            <vs-radio v-model="contact.tHouseHoldType" vs-value="tOwnResident">Own Resident</vs-radio>
                          </li>
                          <li>
                            <vs-radio v-model="contact.tHouseHoldType" vs-value="tRented">Rented</vs-radio>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div v-if="contact.tHouseHoldType" class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span>Living in this address</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <datepicker placeholder="Select Date" v-model="contact.tLivingInThisAddress"></datepicker>
                      </div>
                    </div>
                    <div v-if="contact.tLivingInThisAddress" class="vx-row mb-6">
                      <div class="vx-col sm:w-1/1 w-full">
                        <vs-checkbox vs-value="Luis Daniel" @change="sameAsAddress">Same as Present Address</vs-checkbox>
                      </div>
                    </div>
                  </vx-card>
                </div>
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-col w-full">
                  <vx-card title="Permanent Address">
                    <div class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span>Division</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <template>
                          <v-select label="name" v-model="contact.pDevision" class="w-full select-large"
                                    :options="division"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                        </template>
                      </div>
                    </div>
                    <div v-if="contact.pDevision" class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span>District</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <template>
                          <v-select label="name" v-model="contact.pDistrict" class="w-full select-large"
                                    :options="district"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                        </template>
                      </div>
                    </div>
                    <div v-if="contact.pDistrict" class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span>Thana</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <template>
                          <v-select label="name" v-model="contact.pThana" class="w-full select-large" :options="thana"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                        </template>
                      </div>
                    </div>
                    <div v-if="contact.pThana" class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span>Apt#/House#/Road#/Village#</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <vs-input class="w-full" type="text" v-model="contact.pAptHouseRoadVill"/>
                      </div>
                    </div>
                    <div v-if="contact.pAptHouseRoadVill" class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span>Nearby Famous Landmark </span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <vs-input class="w-full" type="text" v-model="contact.pNearByLandmark"/>
                      </div>
                    </div>
                    <div v-if="contact.pNearByLandmark" class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span>Postal code</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <vs-input class="w-full" type="text" v-model="contact.pPostalCode"/>
                      </div>
                    </div>
                    <div v-if="contact.pPostalCode" class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span>Household Type</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <ul class="demo-alignment">
                          <li>
                            <vs-radio v-model="contact.pHouseHoldType" vs-value="pOwnResident">Own Resident</vs-radio>
                          </li>
                          <li>
                            <vs-radio v-model="contact.pHouseHoldType" vs-value="pRented">Rented</vs-radio>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div v-if="contact.pHouseHoldType" class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full">
                        <span>Living in this address</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <datepicker placeholder="Select Date" v-model="contact.pLivingInThisAddress"></datepicker>
                      </div>
                    </div>
                    <!--                    <div class="vx-row ">-->
                    <!--                      <div class="vx-col sm:w-1/1 w-full mb-2 text-right">-->
                    <!--                        <vs-button   color="success" type="gradient" icon-pack="feather" icon="icon-save" icon-before @click="savaContactInfo()">Save as draft</vs-button>-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                  </vx-card>
                  <div class="vx-row">
                    <div class="vx-col w-full text-right">
                      <vs-button  color="success" class="mr-3 mb-2 float-right" @click="savaContactInfo()">Save
                      </vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </tab-content>

          <!-- tab 3 content -->
          <tab-content title="Occupational Information" :before-change="saveOccuBynext" class="mb-5" icon="feather icon-image">
            <br>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full mt-2">
                    <span>Occupation Type</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <ul class="demo-alignment">
                      <li>
                        <vs-radio v-model="occupation.occupationType" vs-value="Employed">Employed</vs-radio>
                      </li>
                      <li>
                        <vs-radio v-model="occupation.occupationType" vs-value="Self-Employed">Self-Employed</vs-radio>
                      </li>
                      <li>
                        <vs-radio v-model="occupation.occupationType" vs-value="Unemployed">Unemployed</vs-radio>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full mt-2">
                    <span>Occupation</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <template>
                      <v-select label="occuName" v-model="occupation.occupationName" class="w-full select-large"
                                :options="occupationDrop" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full mt-2">
                    <span>Monthly Income In BDT</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="number" v-model="occupation.monthlyIncome"/>
                  </div>
                </div>
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full mt-2">
                    <span>Name of the Office/Business </span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="occupation.officeOrBusinessNm"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full mt-2">
                    <span>Designation</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="occupation.designation"/>
                  </div>
                </div>
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full mt-2">
                    <span>Job length</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <div class="demo-alignment">
                      <vs-input class="mt-0"  type="text" v-model="occupation.year" placeholder="Year"/>
                      <template>
                        <v-select v-model="occupation.month" class="select-large mt-0" style="width:120px" placeholder="Months" :options="dependantDrop"
                                  :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <!--<div class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full mt-2">
                    <span>Job length</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <div class="demo-alignment">
                      &lt;!&ndash;                    <datepicker placeholder="Select Date" v-model="occupation.jobLength"></datepicker>&ndash;&gt;
                      <vs-input class="mt-0"  type="text" v-model="occupation.year" placeholder="Year"/>
                      <vs-input class="mt-0"  type="text" v-model="occupation.month" placeholder="Months"/>
                    </div>
                  </div>
                </div>
              </div>-->
            </div>
            <div class="vx-row">
              <vx-card title="Occupation Address">
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                    <div class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full mt-2">
                        <span>Division</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <template>
                          <v-select label="name" v-model="occupation.occDivision" class="w-full select-large"
                                    :options="division"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div v-if="occupation.occDivision" class="vx-col sm:w-1/2 w-full mb-2">
                    <div class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full mt-2">
                        <span>District</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <template>
                          <v-select label="name" v-model="occupation.occDistrict" class="w-full select-large"
                                    :options="district"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="occupation.occDistrict" class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                    <div class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full mt-2">
                        <span>Thana</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <template>
                          <v-select label="name" v-model="occupation.occThana" class="w-full select-large"
                                    :options="thana"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div v-if="occupation.occThana" class="vx-col sm:w-1/2 w-full mb-2">
                    <div class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full mt-2">
                        <span>Office Area</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <vs-input class="w-full" type="text" v-model="occupation.officeArea"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="occupation.officeArea" class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                    <div class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full mt-2">
                        <span>Apt#/House#/Road#/Village# </span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <vs-input class="w-full" type="text" v-model="occupation.ofcAptHouseRoadVill"/>
                      </div>
                    </div>
                  </div>
                  <div v-if="occupation.ofcAptHouseRoadVill" class="vx-col sm:w-1/2 w-full mb-2">
                    <div class="vx-row mb-6">
                      <div class="vx-col sm:w-1/3 w-full mt-2">
                        <span>Postal code</span>
                      </div>
                      <div class="vx-col sm:w-2/3 w-full">
                        <vs-input class="w-full" type="text" v-model="occupation.ofcPostalCode"/>
                      </div>
                    </div>
                  </div>
                </div>
                <!--                <div class="vx-row ">-->
                <!--                  <div class="vx-col sm:w-1/1 w-full mb-2 text-right">-->
                <!--                    <vs-button   color="success" type="gradient" icon-pack="feather" icon="icon-save" icon-before @click="savaOccupationInfo()">Save as draft</vs-button>-->
                <!--                  </div>-->
                <!--                </div>-->
                <div class="vx-row">
                  <div class="vx-col w-full text-right">
                    <vs-button color="success" class="mr-3 mb-2 float-right" @click="savaOccupationInfo()">Save
                    </vs-button>
                  </div>
                </div>
              </vx-card>
            </div>
          </tab-content>
          <!-- tab 4 content  -->
          <tab-content title="Dependent Information" :before-change="saveDependentInfo" class="mb-5"
                       icon="feather icon-image">
            <br>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full mt-10">
                    <span> No. of Children living with you</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full mt-10">
                    <template>
                      <v-select v-model="dependent.noOfChildren" class="w-full select-large" :options="dependantDrop"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    </template>
                  </div>
                </div>
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full mt-10">
                    <span> No. of dependent living with you</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full mt-10">
                    <template>
                      <v-select v-model="dependent.noOfDependent" class="w-full select-large" :options="dependantDrop"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                    </template>

                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <vx-card title="Depandant Details">
                <div class="vx-row" v-for='(dependentDetail, index) in dependent.dependentDetails' :key='index'>
                  <div class="vx-col sm:w-1/5 w-full mb-2">
                    <div class="vx-row mb-6">
                      <div class="vx-col w-full">
                        <template>
                          <v-select v-model="dependentDetail.relation" name="relationShip"
                                    placeholder="Relation"
                                    class="w-full select-large" :options="relationShipDrop"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div class="vx-col sm:w-1/5 w-full mb-2">
                    <div class="vx-row mb-6">
                      <div class="vx-col w-full">
                        <vs-input class="w-full" placeholder="Name" type="text" name="name"
                                  v-model="dependentDetail.name"/>
                      </div>
                    </div>
                  </div>
                  <div class="vx-col sm:w-1/5 w-full mb-2">
                    <div class="vx-row mb-6">
                      <div class="vx-col w-full">
                        <vs-input class="w-full" placeholder="Age" type="text" name="age"
                                  v-model="dependentDetail.age"/>
                      </div>
                    </div>
                  </div>
                  <div v-if="dependentDetail.relationShip == 'Others'" class="vx-col sm:w-1/5 w-full mb-2">
                    <div class="vx-row mb-6">
                      <div class="vx-col  w-full">
                        <vs-input class="w-full" type="text" placeholder="Other dependents living with you"
                                  name="other" v-model="dependentDetail.otherDependant"/>
                      </div>
                    </div>
                  </div>
                  <div class="vx-col sm:w-1/5 w-full mb-2">
                    <div class="vx-row mb-6">
                      <div class="vx-col w-full">
                        <vs-button radius color="danger" type="flat" icon-pack="feather" icon="icon-archive"
                                   @click.prevent="removeDependend(index)"></vs-button>
                      </div>
                    </div>
                  </div>
                </div>
                <vs-button color="success" type="filled" @click="addMoreDependend()">Add Dependent Details</vs-button>
              </vx-card>
            </div>
            <!--<div class="vx-row">
              <div class="vx-col w-full text-right">
                <vs-button color="success" class="mr-3 mb-2 float-right" icon-pack="feather" icon="icon-save"
                           icon-before @click="updateDependentInfo()">Save
                </vs-button>
              </div>
            </div>-->
          </tab-content>
        </form-wizard>
      </div>
    </vx-card>
  </div>


</template>

<script>
  import guarantorPersonal from '../graphql/GuarantorPersonal.gql'
  import guarantorContact from '../graphql/GuarantorContact.gql'
  import guarantorOccupation from '../graphql/GuarantorOccupation.gql'
  import guarantorDependent from '../graphql/GuarantorDependent.gql'
  import gql from 'graphql-tag'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import vSelect from 'vue-select'
  import Datepicker from 'vuejs-datepicker'
  import { Validator } from 'vee-validate';
  const dict = {
    custom: {
      nid_No: {
        required: 'Nid No is required',
        //alpha: "First name may only contain alphabetic characters"
      },
    }
  };
  Validator.localize('en', dict);
  export default {
    data () {
      return {
        gurantorId :'',
        ekycId : '',
        userInfo: '',
        contactTab: true,
        showNidError : false,
        personal: {
          applicantName: '',
          fathersName: '',
          motherName: '',
          spouseName: '',
          age: '',
          maritalStatus: '',
          gender: '',
          headOfHousehold: true,
          education: '',
          nidNo: '',
          nidFrontImage: '',
          nidBackImage: '',
          applicantPhoto: ''
        },
        contact: {
          mobile: '',
          otherPhone: '',
          email: '',
          tDevision: '',
          tDistrict: '',
          tThana: '',
          tAptHouseRoadVill: '',
          tNearByLandmark: '',
          tPostalCode: '',
          tHouseHoldType: '',
          tLivingInThisAddress: '',
          pDevision: '',
          pDistrict: '',
          pThana: '',
          pAptHouseRoadVill: '',
          pNearByPlace: '',
          pNearByLandmark: '',
          pPostalCode: '',
          pHouseHoldType: '',
          pLivingInThisAddress: ''
        },
        occupation: {
          occupationType: '',
          occupationName: '',
          monthlyIncome: '',
          officeOrBusinessNm: '',
          designation: '',
          year:'',
          month:'',
          jobLength: '',
          occDivision: '',
          occDistrict: '',
          occThana: '',
          officeArea: '',
          ofcAptHouseRoadVill: '',
          ofcPostalCode: ''
        },
        dependent: {
          noOfChildren: 0,
          noOfDependent: 0,
          dependentDetails: [{
            id: '',
            relation: '',
            name: '',
            age: '',
            otherDependant: ''
          }]
        },
        relationShipDrop: ['Children', 'Parents', 'Others'],
        dependantDrop: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10,11,12],
        educationLevelOpt: [
          {
            text: 'SSC or O Level',
            value: 'SSC or O Level'
          },
          {
            text: 'HSC or A Level',
            value: 'HSC or A Level'
          },
          {
            text: 'Diploma',
            value: 'Diploma'
          },
          {
            text: 'Bachelor\'s ',
            value: 'Bachelor\'s '
          },
          {
            text: 'Master\'s',
            value: 'Master\'s'
          },
          {
            text: 'Doctorate',
            value: 'Doctorate'
          }
        ],
        division: [
          {
            id: 1,
            name: 'Dhaka'
          },
          {
            id: 2,
            name: 'Khulna'
          }
        ],
        district: [
          {
            id: 1,
            name: 'Dhaka'
          },
          {
            id: 2,
            name: 'Savar'
          }
        ],
        thana: [
          {
            id: 1,
            name: 'Mohammadpur'
          },
          {
            id: 2,
            name: 'Dhanmondi'
          }
        ],
        occupationDrop: [
          {
            id: 1,
            occuName: 'Government'
          },
          {
            id: 2,
            occuName: 'Non-Government'
          },
          {
            id: 3,
            occuName: 'Teacher'
          }
        ]
      }
    },
     apollo: {
       GuarantorByID:{
         query: gql`
         query GuarantorByID($id: ID!){
          GuarantorByID(id:$id){
            id
            name
            phone
            email
            relationship
            status
            token
            ekyc {
              id
              phone
              nid
              email
              status
              parsonal {
                id
                name
                father_name
                mother_name
                spouse_name
                age
                marital_status
                gender
                head_of_household
                education_level
                nid
              }
              contact {
                id
                mobile
                other_phone
                email
                presentAddress {
                  id
                  division
                  district
                  thana
                  address
                  near_landmark
                  postal_code
                  house_hold_type
                  living_in_this_address
                }
                permanentAddress {
                  id
                  pdivision
                  pdistrict
                  pthana
                  paddress
                  pnear_landmark
                  ppostal_code
                  phouse_hold_type
                  pliving_in_this_address
                }
              }
              occupation {
                id
                occupation_type
                occupation
                monthly_income
                name_of_Office_or_business
                designation
                job_length
                occupationAddress {
                  id
                  division
                  district
                  thana
                  office_area
                  address
                  postal_code
                }
              }
              dependent {
                id
                number_of_child
                number_of_dependent
                depandantDetails {
                  id
                  relation
                  name
                  age
                }
              }
            }
          }
         }
         `,
         variables () {
           return {
             id: this.$route.params.guarantorId
           }
         },
         update: (data) => data.GuarantorByID
       }

    },
    watch:{
      GuarantorByID(value){
        console.log("Guarantor by Id: ", value);
        this.userInfo = value;
        this.contact.mobile = value.phone;
        this.contact.email = value.email || "";
        if (this.userInfo !== null) {
          if(this.userInfo.ekyc.parsonal !== null){
            this.personal.applicantName = this.userInfo.ekyc.parsonal.name
            this.personal.fathersName = this.userInfo.ekyc.parsonal.father_name
            this.personal.motherName = this.userInfo.ekyc.parsonal.mother_name
            this.personal.spouseName = this.userInfo.ekyc.parsonal.spouse_name
            this.personal.age = this.userInfo.ekyc.parsonal.age
            this.personal.maritalStatus = this.userInfo.ekyc.parsonal.marital_status
            this.personal.gender = this.userInfo.ekyc.parsonal.gender
            this.personal.headOfHousehold = this.userInfo.ekyc.parsonal.head_of_household
            this.personal.education = this.userInfo.ekyc.parsonal.education_level
            this.personal.nidNo = this.userInfo.ekyc.parsonal.nid
          };
          this.contact.mobile = this.userInfo.ekyc.phone;
          if(this.userInfo.ekyc.contact !== null){
            this.contact.id = this.userInfo.ekyc.contact.id
            this.contact.otherPhone = this.userInfo.ekyc.contact.other_phone
            this.contact.email = this.userInfo.ekyc.contact.email
            this.contact.tDevision = this.userInfo.ekyc.contact.presentAddress.division
            this.contact.tDistrict = this.userInfo.ekyc.contact.presentAddress.district
            this.contact.tThana = this.userInfo.ekyc.contact.presentAddress.thana
            this.contact.tAptHouseRoadVill = this.userInfo.ekyc.contact.presentAddress.address
            this.contact.tNearByLandmark = this.userInfo.ekyc.contact.presentAddress.near_landmark
            this.contact.tPostalCode = this.userInfo.ekyc.contact.presentAddress.postal_code
            this.contact.tHouseHoldType = this.userInfo.ekyc.contact.presentAddress.house_hold_type
            this.contact.tLivingInThisAddress = this.userInfo.ekyc.contact.presentAddress.living_in_this_address
            this.contact.pDevision = this.userInfo.ekyc.contact.permanentAddress.pdivision
            this.contact.pDistrict = this.userInfo.ekyc.contact.permanentAddress.pdistrict
            this.contact.pThana = this.userInfo.ekyc.contact.permanentAddress.pthana
            this.contact.pAptHouseRoadVill = this.userInfo.ekyc.contact.permanentAddress.paddress
            this.contact.pNearByLandmark = this.userInfo.ekyc.contact.permanentAddress.pnear_landmark
            this.contact.pPostalCode = this.userInfo.ekyc.contact.permanentAddress.ppostal_code
            this.contact.pHouseHoldType = this.userInfo.ekyc.contact.permanentAddress.phouse_hold_type
            this.contact.pLivingInThisAddress = this.userInfo.ekyc.contact.permanentAddress.pliving_in_this_address
          };

          if(this.userInfo.ekyc.occupation !==null){
            this.occupation.occupationType = this.userInfo.ekyc.occupation.occupation_type
            this.occupation.occupationName = this.userInfo.ekyc.occupation.occupation
            this.occupation.monthlyIncome = this.userInfo.ekyc.occupation.monthly_income
            this.occupation.officeOrBusinessNm = this.userInfo.ekyc.occupation.name_of_Office_or_business
            this.occupation.designation = this.userInfo.ekyc.occupation.designation
            this.occupation.jobLength = this.userInfo.ekyc.occupation.job_length
            this.occupation.occDivision = this.userInfo.ekyc.occupation.occupationAddress.division
            this.occupation.occDistrict = this.userInfo.ekyc.occupation.occupationAddress.district
            this.occupation.occThana = this.userInfo.ekyc.occupation.occupationAddress.thana
            this.occupation.officeArea = this.userInfo.ekyc.occupation.occupationAddress.office_area
            this.occupation.ofcAptHouseRoadVill = this.userInfo.ekyc.occupation.occupationAddress.address
            this.occupation.ofcPostalCode = this.userInfo.ekyc.occupation.occupationAddress.postal_code
          };
          if(this.userInfo.ekyc.dependent !==null){
            this.dependent.noOfChildren = this.userInfo.ekyc.dependent.number_of_child
            this.dependent.noOfDependent = this.userInfo.ekyc.dependent.number_of_dependent
            this.dependent.dependentDetails = this.userInfo.ekyc.dependent.depandantDetails
          };
        }
      }
    },
    methods: {
      addMoreDependend () {
        this.dependent.dependentDetails.push({
          relation: '',
          name: '',
          age: '',
          otherDependant: ''
        })
        console.log('Add', this.dependent.dependentDetails)
      },
      removeDependend (i) {
        this.dependent.dependentDetails.splice(i, 1)
        console.log('removeDependend = ', this.dependent.dependentDetails)
      },
      sameAsAddress(){
        console.log("Same ass");
        this.contact.pDevision = this.contact.tDevision;
        this.contact.pDistrict =this.contact.tDistrict;
        this.contact.pThana =this.contact.tThana;
        this.contact.pAptHouseRoadVill =this.contact.tAptHouseRoadVill;
        this.contact.pNearByLandmark =this.contact.tNearByLandmark;
        this.contact.pPostalCode =this.contact.tPostalCode;
        if(this.contact.tHouseHoldType === 'tOwnResident'){
          this.contact.pHouseHoldType ='pOwnResident';
        }else {
          this.contact.pHouseHoldType = 'pRented';
        }
        //this.contact.pHouseHoldType =this.contact.tHouseHoldType;
        this.contact.pLivingInThisAddress =this.contact.tLivingInThisAddress
      },
      savaPersonalInfoifNoError(){
        return new Promise((resolve, reject) => {
          this.$validator.validateAll('step-1').then(result => {
            if (result) {
              resolve(true)
              if(this.personal.nidNo !== null){
                this.savaPersonalInfo ();
              }
              this.showNidError = false;
            } else {
              reject("correct all values");
              this.showNidError = true;
            }
          })
        })
      },
      async savaPersonalInfo () {
        console.log("Save :", this.personal);
        console.log("guarantorId :", this.$route.params.guarantorId);
        console.log("ekycId :", this.$route.params.ekycId);
          await this.$apollo.mutate({
            mutation: guarantorPersonal,
            variables: {
              guarantor_id: this.$route.params.guarantorId,
              ekyc_id: this.$route.params.ekycId || "",
              name: this.personal.applicantName,
              father_name: this.personal.fathersName,
              mother_name: this.personal.motherName,
              spouse_name: this.personal.spouseName,
              age: this.personal.age,
              marital_status: this.personal.maritalStatus,
              gender: this.personal.gender,
              head_of_household: this.personal.headOfHousehold,
              education_level: this.personal.education ===null? "": this.personal.education.value,
              nid: this.personal.nidNo,
              nid_front: this.personal.nidFrontImage,
              nid_back: this.personal.nidBackImage,
              photo: this.personal.applicantPhoto
            }
          }).then((data) => {
            console.log('Data = ', data);
            this.$vs.notify({
              title: 'Saved',
              text: 'Personal Information Successfully Saved.',
              color: "success",
              position: 'top-right'
            })
            this.contactTab = true
            console.log('this.contactTab = ', this.contactTab)
          }).catch((error) => {
          })

      },
      async savaContactInfo () {
        console.log("Save", this.contact);
        console.log("ekycId :", this.$route.params.ekycId);
          await this.$apollo.mutate({
            mutation: guarantorContact,
            variables: {
              ekyc_id: this.$route.params.ekycId || "",
              other_phone: this.contact.otherPhone === null? "":this.contact.otherPhone,
              email: this.contact.email === null? "":this.contact.email,
              division: this.contact.tDevision === null? "": this.contact.tDevision.name,
              district: this.contact.tDistrict ===null? "": this.contact.tDistrict.name,
              thana: this.contact.tThana === null? "" : this.contact.tThana.name,
              address: this.contact.tAptHouseRoadVill === null? "":this.contact.tAptHouseRoadVill,
              near_landmark: this.contact.tNearByLandmark === null? "": this.contact.tNearByLandmark,
              postal_code: this.contact.tPostalCode === null? "": this.contact.tPostalCode,
              house_hold_type: this.contact.tHouseHoldType === null? "": this.contact.tHouseHoldType,
              living_in_this_address: this.contact.tLivingInThisAddress === null? "": this.contact.tLivingInThisAddress,
              pdivision: this.contact.pDevision ===null? "" : this.contact.pDevision.name,
              pdistrict: this.contact.pDistrict === null? "" : this.contact.pDistrict.name,
              pthana: this.contact.pThana ===null? "" : this.contact.pThana.name,
              paddress: this.contact.pAptHouseRoadVill === null? "":this.contact.pAptHouseRoadVill,
              pnear_landmark: this.contact.pNearByLandmark === null? "":this.contact.pNearByLandmark,
              ppostal_code: this.contact.pPostalCode === null? "":this.contact.pPostalCode,
              phouse_hold_type: this.contact.pHouseHoldType === null? "":this.contact.pHouseHoldType,
              pliving_in_this_address: this.contact.pLivingInThisAddress === null? "":this.contact.pLivingInThisAddress
            }
          }).then((data) => {
            console.log('Data = ', data);
            this.$vs.notify({
              title: 'Saved',
              text: 'Contact Information Successfully Saved.',
              color: "success",
              position: 'top-right'
            })
            this.contactTab = true
            console.log('this.contactTab = ', this.contactTab)
          }).catch((error) => {
          })


      },
      async savaOccupationInfo () {
        console.log("SaveOccu:",this.occupation);
        console.log("ekycId :", this.$route.params.ekycId);
          await this.$apollo.mutate({
            mutation: guarantorOccupation,
            variables: {
              ekyc_id: this.$route.params.ekycId || "",
              occupation_type: this.occupation.occupationType,
              occupation: this.occupation.occupationName === null?"": this.occupation.occupationName.occuName,
              monthly_income: this.occupation.monthlyIncome,
              name_of_Office_or_business: this.occupation.officeOrBusinessNm,
              designation: this.occupation.designation,
              job_length: this.occupation.year +','+ this.occupation.month,
              division: this.occupation.occDivision ===null? "": this.occupation.occDivision.name,
              district: this.occupation.occDistrict ===null? "": this.occupation.occDistrict.name,
              thana: this.occupation.occThana ===null? "": this.occupation.occThana.name,
              office_area: this.occupation.officeArea ===null? "": this.occupation.officeArea,
              address: this.occupation.ofcAptHouseRoadVill ===null? "": this.occupation.ofcAptHouseRoadVill,
              postal_code: this.occupation.ofcPostalCode ===null? "": this.occupation.ofcPostalCode,
            }
          }).then((data) => {
            console.log('Data = ', data);
            this.$vs.notify({
              title: 'Saved',
              text: 'Occupation Information Successfully Saved.',
              color: "success",
              position: 'top-right'
            })
            this.contactTab = true
            console.log('this.contactTab = ', this.contactTab)
          }).catch((error) => {
            this.$vs.notify({
              title: 'Error!',
              text: 'Something went wrong.',
              color: "danger",
              position: 'top-right'
            })
          })


      },
      async saveDependentInfo () {
        console.log("Save Dep",this.dependent);
        console.log("ekycId :", this.$route.params.ekycId);
          await this.$apollo.mutate({
            mutation: guarantorDependent,
            variables: {
              ekyc_id: this.$route.params.ekycId || "",
              number_of_child: this.dependent.noOfChildren,
              number_of_dependent: this.dependent.noOfDependent,
              //depandantDetails:this.dependent.dependentDetails
              depandantDetail: this.dependent.dependentDetails.map(v => {
                return {
                  relation: v.relation,
                  name: v.name,
                  age: v.age+""
                }
              })
            }
          }).then((data) => {
            console.log('Dep Data = ', data);
            this.$router.push('/submitted').catch(() => {});
            this.$vs.notify({
              title: ' Saved',
              text: 'Dependant Information Successfully Saved.',
              color: "success",
              position: 'top-right'
            })
            this.contactTab = true
            console.log('this.contactTab = ', this.contactTab);
          }).catch((error) => {
            this.$vs.notify({
              title: 'Error!',
              text: 'Something went wrong.',
              color: "danger",
              position: 'top-right'
            })
          })
      },
      beforeTabSwitch2: function () {
        this.savaContactInfo ();
        return true
      },
      saveOccuBynext: function () {
        this.savaOccupationInfo ();
        return true
      },
      formSubmitted () {
        alert('Form submitted!')
      },
      submitApplicantInfo (personal) {
        console.log('personal info = ', personal)
      },
      successNidUpload () {
        this.$vs.notify({
          color: 'success',
          title: 'Upload Success',
          text: 'NID Successfully Uploaded'
        })
      },
      successUpload () {
        this.$vs.notify({
          color: 'success',
          title: 'Upload Success',
          text: 'Photo Successfully Uploaded'
        })
      },
      validateStep1() {
        return new Promise((resolve, reject) => {
          this.$validator.validateAll('step-1').then(result => {
            if (result) {
              resolve(true)
              if(this.personal.nidNo !== null){
                this.savaPersonalInfo ();
              }
              this.showNidError = false;
            } else {
              reject("correct all values");
              this.showNidError = true;
            }
          })
        })
      },
      // nextTab: function () {
      //   if(this.personal.nidNo !== null){
      //     this.savaPersonalInfo ();
      //   }
      //   if (this.contactTab)
      //     return true
      // }
    },
    components: {
      FormWizard,
      TabContent,
      'v-select': vSelect,
      Datepicker
    }
  }
</script>
